export * from './auth'
export * from './firestore'

import * as chats from './references/chats'
import * as messages from './references/messages'
import * as reads from './references/reads'
import * as typings from './references/typings'

const fireChat = {
  ...chats,
  ...messages,
  ...reads,
  ...typings,
}

export default fireChat
